import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconAlignJustify = (props?: SvgProps) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M17.75 8.33333H2.75M17.75 15H2.75M17.75 5H2.75M17.75 11.6667H2.75"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
